// extracted by mini-css-extract-plugin
export default {"container":"datatable_container__1m-My"};